/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

export const HIDE_TOPBAR_BODY_CLASS = 'orangehrm-page--hide-topbar-body';

const HIDE_TOPBAR_BODY_PATTERN =
  /\/(dashboard\/index|buzz\/viewBuzz)(?:\/|$|\?|#)/;

export const shouldHideTopbarBody = (pathname = window.location.pathname) =>
  HIDE_TOPBAR_BODY_PATTERN.test(pathname);

export const syncHideTopbarBodyClass = (
  pathname = window.location.pathname,
): void => {
  document.documentElement.classList.toggle(
    HIDE_TOPBAR_BODY_CLASS,
    shouldHideTopbarBody(pathname),
  );
};
